<template>
  <div class="backimg"></div>
  <div class="content-container">
    <!-- Toast Message -->
    <transition name="v">
      <div v-if="showMessage && message" class="fixed top-0 right-0 m-4 p-4 bg-red-600 text-white rounded">
        {{ message }}
        <a href="#" class="ml-4 text-white underline" @click.prevent="closeMessage">Close</a>
      </div>
    </transition>

    <div class="flex items-center justify-center min-h-screen">
      <div class="bg-white dark:bg-gray-800 shadow-md rounded-lg p-8 w-96 z-10 flex flex-col items-center justify-center">
        <img class="h-12 mb-12" alt="logo" src="/assets/aim_logo_big.png">
        <h1 class="text-2xl mb-8 text-center text-gray-700 dark:text-gray-200">Sign in to your account</h1>
      <!-- Standard Login Form -->
      <!-- <form @submit.prevent="performLogin" name="login-form" class="w-full max-w-sm mt-4">
        <div class="mb-4">
          <label for="email" class="block text-sm font-bold">Email</label>
          <input
            :disabled="isLoggingIn"
            type="email"
            id="email"
            v-model="account.email"
            @blur="validateEmail"
            :class="emailError ? 'txt-custom-color' : ''"
            class="mt-1 p-2 w-full border rounded-md"
            @keyup.enter="performLogin"
            autocomplete="username"
          />
          <p v-if="emailError" class="txt-custom-color text-xs">{{ emailError }}</p>
        </div>

        <div class="mb-4 text-left">
          <label for="password" class="block text-sm font-bold">Password</label>
          <input
            :disabled="isLoggingIn"
            type="password"
            id="password"
            v-model="account.password"
            @blur="validatePassword"
            :class="passwordError ? 'border-yellow-500' : ''"
            class="mt-1 p-2 w-full border rounded-md"
            @keyup.enter="performLogin"
            autocomplete="current-password"
          />
          <p v-if="passwordError" class="txt-custom-color text-xs">{{ passwordError }}</p>
          <a href="/forgot" class="self-end text-gray-500 text-sm self-end">Forgot Password?</a>
        </div>

        <p v-if="apiError" class="txt-custom-color text-xs">{{ apiError }}</p>
        <button :disabled="isLoggingIn" class="mt-4 w-full px-4 py-2 login-custom-color text-white rounded hover:bg-opacity-90">Login</button>
      </form> -->


      <!-- OpenID Login -->
      <button @click="performMicrosoftLogin" :disabled="isLoggingIn"
          class="w-80 py-2 bg-gray-500 text-white font-semibold rounded-xl hover:bg-gray-600 mb-4">Sign On Using Microsoft
      </button>
      <button @click="performOpenIDLogin" class="mt-4 font-semibold text-blue-500 hover:underline text-sm">
        Use Single Sign On (SSO)
      </button>
      <router-link to="/password-login" class="mt-4 font-semibold text-blue-500 hover:underline text-sm">
        Use password instead
      </router-link>
      <p class="text-xs text-gray-400 mt-6">© 2025 - AIM IT Services</p>
      </div>

    </div>
  </div>
</template>

<script>
import Oidc from 'oidc-client';
import { mapActions, useStore } from 'vuex';
import { useJwt } from '@vueuse/integrations/useJwt';

export default {
  name: 'CombinedLogin',
  computed: {
    message() {
      return this.$route.query.message;
    },
    getLogoPath () {
      const store = useStore();
      return `/assets/logos/${store.state.logo || localStorage.getItem('logo')}`;
    }
  },
  methods: {
    closeMessage() {
      this.showMessage = false;
    },
    ...mapActions(['login']),
    validateEmail() {
      const re = /\S+@\S+\.\S+/;
      if (!re.test(this.account.email)) {
        this.emailError = 'Invalid email address';
      } else {
        this.emailError = '';
      }
    },
    validatePassword() {
      if (this.account.password.length < 8) {
        this.passwordError = 'Password must be at least 8 characters long';
      } else {
        this.passwordError = '';
      }
    },
    async performLogin() {
      this.apiError = '';
      this.validateEmail();
      this.validatePassword();

      if (this.emailError || this.passwordError) return;
      this.$updateLoading(1);
      try {
        this.isLoggingIn = true;
        const response = await this.login(this.account);

        if (response && response.data && response.data.success && response.data.success.token) {
          // Assuming the token is what determines a successful login
          // Store the token, if necessary
          localStorage.setItem('token', response.data.success.token);
          localStorage.setItem('load_default_view', 'true');
          try {
            const { payload } = useJwt(response.data.success.token);
            const isInternal = payload.value.scopes && (payload.value.scopes.includes('internal') || payload.value.scopes.includes('extTech'));

            // Store the internal status
            localStorage.setItem('internal', isInternal);
          } catch (decodeError) {
            console.error('Error decoding token:', decodeError);
          }

          // localStorage.setItem('internal', response.data.success.internal);

          // Emit socket event, if necessary
          const userId = response.data.success.id;
          localStorage.setItem('user_id', userId);
          this.$updateLoading(-1);
        const currentDomain = window.location.origin;
        const redirect = localStorage.getItem('redirectAfterLogin');
        localStorage.removeItem('redirectAfterLogin');
        const redirectPath = redirect ? JSON.parse(redirect).path : '/';
        // this.$router.push(redirectPath);
        window.location.href = `${currentDomain}${redirectPath}`;
        } else {
          console.log(response);
          // if (response.data.error && response == 'Unauthorized') {
          //   this.apiError = 'Login failed, Credentials do not match.';
          // } else {
            this.apiError = response.data.error;
          // }
          
        }
      } catch (error) {
        console.error('Error during login:', error);
        this.apiError = 'Unknown error occurred, please try again later.';
      } finally {
        this.isLoggingIn = false;
        this.$updateLoading(-1);
      }
    },
    performOpenIDLogin() {
      const oidcClient = new Oidc.UserManager({
        authority: process.env.VUE_APP_SSO_OAUTH_URL,
        client_id: process.env.VUE_APP_SSO_CLIENT_ID,
        client_secret: process.env.VUE_APP_SSO_SECRET,
        redirect_uri: `${window.location.origin}/callback`,
        response_type: 'code',
        scope: 'openid email profile'
      });
      localStorage.setItem('load_default_view', 'true');
      this.isLoggingIn = true;
      oidcClient.signinRedirect().catch(err => {
        console.error(err);
        this.apiError = 'Error initiating login with OpenID provider.';
        this.isLoggingIn = false;
      });
    },
    performMicrosoftLogin() {
      const oidcClient = new Oidc.UserManager({
        authority: process.env.VUE_APP_MS_OAUTH_URL,
        client_id: process.env.VUE_APP_MS_CLIENT_ID,
        client_secret: process.env.VUE_APP_MS_SECRET,
        redirect_uri: `${window.location.origin}/callback-microsoft`,
        response_type: 'code',
        scope: 'openid email profile'
      });
      localStorage.setItem('load_default_view', 'true');
      this.isLoggingIn = true;
      oidcClient.signinRedirect().catch(err => {
        console.error(err);
        this.apiError = 'Error initiating login with Microsoft provider.';
        this.isLoggingIn = false;
      });
    }
  },
  data() {
    return {
      account: {
        email: '',
        password: ''
      },
      emailError: '',
      passwordError: '',
      apiError: '',
      isLoggingIn: false,
      showMessage: true,
      messageTimeout: null,
    };
  },
  created() {
    const token = localStorage.getItem('token');
    if (token) {
      this.$router.push('/');
    }
    if (this.message) {
      this.messageTimeout = setTimeout(() => {
        this.showMessage = false;
      }, 3500);
    }
  },
  beforeUnmount() {
    clearTimeout(this.messageTimeout);
  }
};
</script>

<style>
.v-enter-active, .v-leave-active {
  transition: opacity 3s;
}
.v-enter, .v-leave-to {
  opacity: 0;
}

.btn-custom-color {
  background-color: #fbbb05; /* Your desired color */
  color: white; /* Set text color to ensure visibility */
}

.txt-custom-color {
  color: #fbbb05; /* Set text color to ensure visibility */
}


.btn-custom-color:hover {
  background-color: #e0a800; /* Slightly darker for hover effect */
}

.login-custom-color {
  background-color: #696969; /* Your desired color */
  color: white; /* Set text color to ensure visibility */
}


.login-custom-color:hover {
  background-color: #4c4c4c; /* Slightly darker for hover effect */
}


/* Add styles for the disabled state */
.btn-custom-color:disabled {
  background-color: #fbbb05; /* Maintain the background color */
  color: white; /* Maintain the text color */
  opacity: 0.7; /* Optional: Lower opacity to indicate it's disabled */
  cursor: not-allowed; /* Optional: Change cursor to indicate it's not clickable */
}

.backimg {
  opacity: 0.30;
  position: fixed; /* Changed from relative to fixed */
  top: 0; /* Position it at the top of the viewport */
  left: 0; /* Position it at the left of the viewport */
  width: 100vw; /* Span the entire viewport width */
  height: 100vh; /* Span the entire viewport height */
  z-index: -1; /* Place it behind other content */
  background: url('~@/assets/swirl_crop.jpg') no-repeat center center; /* Center the background */
  background-color: #FFF;
  background-size: cover; /* Cover the entire area of the div */
}

.content-container {
  display: flex;
  flex-direction: column;
  justify-content: center; /* Center vertically */
  align-items: center; /* Center horizontally */
  height: 100vh; /* Full viewport height */
  position: relative; /* Ensure it's positioned above the background */
  z-index: 1; /* Higher than the background */
}

</style>
